import React from 'react';

/**
 * A simple loading spinner component to display during loading states
 */
const LoadingSpinner = () => {
  return (
    <div className="flex justify-center items-center h-96">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-t-[var(--c2v-primary)] border-b-[var(--c2v-accent)]"></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default LoadingSpinner;